document.addEventListener("DOMContentLoaded", function () {
  // 🎯 Gestion du champ de recherche
  const searchInput = document.getElementById("searchInput");
  const clearSearchButton = document.getElementById("clearSearch");
  if (clearSearchButton) {
    clearSearchButton.classList.add("ituBtn");
  }

  const blockElement = document.querySelector("[data-table-anchor]");
  const tableAnchorId = blockElement ? blockElement.getAttribute("data-table-anchor") : null;
  const tableAnchor = tableAnchorId ? document.querySelector(`figure#${tableAnchorId} table`) : null;

  if (tableAnchor && tableAnchor.parentElement) {
    const noDataMessage = document.createElement("div");
    noDataMessage.textContent = "Unfortunately, no match was found.";
    noDataMessage.style.display = "none";
    noDataMessage.style.color = "red";
    tableAnchor.parentElement.appendChild(noDataMessage);

    if (searchInput) {
      searchInput.addEventListener("input", function () {
        const searchTerm = this.value.toUpperCase();
        const tableRows = tableAnchor.querySelectorAll("tbody tr");
        let found = false;
        tableRows.forEach((row) => {
          let displayRow = false;
          for (let j = 0; j < row.cells.length; j++) {
            const cell = row.cells[j];
            const cellText = cell.textContent || cell.innerText;
            if (cellText.toUpperCase().includes(searchTerm)) {
              displayRow = true;
              removeHighlights(cell);
              highlightText(cell, searchTerm);
            } else {
              removeHighlights(cell);
            }
          }
          row.style.display = displayRow ? "" : "none";
          if (displayRow) found = true;
        });
        noDataMessage.style.display = found ? "none" : "block";
      });

      clearSearchButton.addEventListener("click", function () {
        searchInput.value = "";
        const tableRows = tableAnchor.querySelectorAll("tbody tr");
        tableRows.forEach((row) => {
          row.style.display = "";
          for (let j = 0; j < row.cells.length; j++) {
            const cell = row.cells[j];
            removeHighlights(cell);
          }
        });
        noDataMessage.style.display = "none";
      });
    }
  }

  function highlightText(element, searchTerm) {
    const regex = new RegExp(`(${searchTerm})`, 'gi');
    const nodes = Array.from(element.childNodes);

    nodes.forEach(node => {
      if (node.nodeType === 3) {
        const newNode = document.createElement('span');
        newNode.innerHTML = node.textContent.replace(regex, '<mark class="highlight">$1</mark>');
        node.replaceWith(newNode);
      } else {
        highlightText(node, searchTerm);
      }
    });
  }

  function removeHighlights(element) {
    const regex = /<mark class="highlight">(.*?)<\/mark>/gi;
    element.innerHTML = element.innerHTML.replace(regex, '$1');
  }

  // 🎯 Mise à jour du logo principal (avec URL cliquable si précisé)
const primaryLogoContainer = document.getElementById("primary-logo-container");
if (primaryLogoContainer) {
  const primaryLogoUrl = primaryLogoContainer.getAttribute("data-logo-url");
  const logoLink = primaryLogoContainer.getAttribute("data-logo-link");

  const logoWrapper = document.getElementById("itu-primary-logo");
  const targetImg = logoWrapper?.querySelector("img");

  if (primaryLogoUrl) {
    if (logoLink) {
      const newLink = document.createElement("a");
      newLink.href = logoLink;
      newLink.target = "_blank";

      const newImg = document.createElement("img");
      newImg.src = primaryLogoUrl;
      newImg.alt = "Primary Logo";

      newLink.appendChild(newImg);

      if (logoWrapper) {
        logoWrapper.replaceWith(newLink);
        newLink.id = "itu-primary-logo"; // on garde l’ID
      }
    } else if (targetImg) {
      targetImg.src = primaryLogoUrl;
    }
  }
}


// ✅ Ajout du bouton personnalisé après le lien "Add event to my calendar"
const calendarBtnPlaceholder = document.getElementById("calendar-button-injection");
if (calendarBtnPlaceholder) {
  const label = calendarBtnPlaceholder.getAttribute("data-label");
  const url = calendarBtnPlaceholder.getAttribute("data-url");

  if (label && url) {
    const buttonsContainer = document.querySelector(".buttons");
    if (buttonsContainer) {
      const btn = document.createElement("button");
      btn.className = "ituBtn";
      btn.id = "submitBtn";
      btn.textContent = label;

      btn.addEventListener("click", () => {
        window.open(url, "_blank");
      });

      buttonsContainer.appendChild(btn);
    }
  }
}


  // 🎯 Insertion du logo d’événement
  const eventLogoContainer = document.getElementById("event-logo-container");
  if (eventLogoContainer) {
    const logoUrl = eventLogoContainer.getAttribute("data-logo-url");
    const logoLink = eventLogoContainer.getAttribute("data-logo-link");

    if (logoUrl && logoLink) {
      const newImage = document.createElement("img");
      newImage.src = logoUrl;
      newImage.alt = "";
      newImage.height = 43;

      const newLink = document.createElement("a");
      newLink.href = logoLink;
      newLink.target = "_blank";

      newLink.appendChild(newImage);

      const primaryLogo = document.getElementById("itu-primary-logo");
      if (primaryLogo) {
        primaryLogo.before(newLink);
      }
    }
  }

  // ✅ Générer automatiquement le sommaire si placeholder présent
  const tocContainer = document.getElementById('table-of-contents-placeholder');
  if (tocContainer) {
    const $ = jQuery;
    const $toc = $('<nav id="table-of-contents"><h2>Sommaire</h2><ul></ul></nav>');
    const $ul = $toc.find('ul');

    $('h2').each(function (index) {
      const $heading = $(this);
      let id = $heading.attr('id');
      if (!id) {
        id = 'section' + (index + 1);
        $heading.attr('id', id);
      }

      const $li = $('<li></li>');
      const $a = $('<a></a>').attr('href', '#' + id).text($heading.text());
      $li.append($a);
      $ul.append($li);
    });

    $(tocContainer).replaceWith($toc);
  }

    // ✅ Remplacement du menu par un menu personnalisé (vanilla JS)
    const customMenuContainer = document.getElementById("custom-menu-container");

    if (customMenuContainer) {
      const itemsJson = customMenuContainer.getAttribute("data-items") || "[]";
      const items = JSON.parse(itemsJson);

      // Masque le menu original
      const originalMenu = document.getElementById("menuItems");
      if (originalMenu) {
        originalMenu.style.display = "none";

        // Crée le nouveau menu
        const newMenu = document.createElement("ul");
        newMenu.className = "displayed-nav-items";
        newMenu.id = "displayed-nav-items";

        items.forEach((item) => {
          if (item.title && item.url) {
            const li = document.createElement("li");
            li.setAttribute("data-span", "3");

            const a = document.createElement("a");
            a.href = item.url;
            a.textContent = item.title;

            li.appendChild(a);
            newMenu.appendChild(li);
          }
        });

        // Insère le nouveau menu après l'ancien
        originalMenu.parentNode.insertBefore(newMenu, originalMenu.nextSibling);
      }
    }
});
